import { IDefaultSortingOrder } from "../../types/SortingOrder";

const getFullName = (person?: {
	lastName?: string;
	firstName?: string;
	fatherName?: string;
}) => {
	if (!person) return "";
	const { lastName = "", firstName = "", fatherName = "" } = person;
	return `${lastName} ${firstName} ${fatherName}`.trim();
};

const getPhone = (person?: { phones?: { number?: string }[] }) => {
	if (!person || !person.phones) return "";
	const phoneFirst = person.phones?.[0]?.number ?? "";
	return `${phoneFirst}`.trim();
};

// -----------------------------------------------------------------

const isQuery = (q: unknown): q is string => typeof q === "string" && q !== "";

const isLimit = (l: unknown): l is number =>
	typeof l === "number" && !Number.isNaN(l) && Number.isFinite(l);

// const isOrder = (o: unknown): o is IDefaultSortingOrder =>
// 	typeof o === "object" && o !== null && !Array.isArray(o);

const sortingOrders = new Set(["ASC", "DESC", "asc", "desc"]);

const isOrder = (o: unknown): o is IDefaultSortingOrder => {
	if (typeof o !== "object" || o === null || Array.isArray(o)) {
		return false;
	}

	for (const key in o) {
		// eslint-disable-next-line no-prototype-builtins
		if (Object.prototype.hasOwnProperty.call(o, key)) {
			const value = (o as Record<string, unknown>)[key];
			if (typeof value !== "string" || !sortingOrders.has(value)) {
				return false;
			}
		}
	}

	return true;
};

export { getFullName, getPhone, isQuery, isLimit, isOrder };
